export const classes = (...args: string[]): string => {
    return args.join(' ');
}